import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import IBAN from './IBAN';

const IbanInput = ({ setIban }) => {
  return (
    <IBAN
      render={({ onChange, value, iban }) => {
        const expr = /^TR\d{7}[0-9]{17}$/.test(iban);
        setTimeout(() => setIban(iban), 0);
        return (
          <React.Fragment>
            <Input
              style={{
                width: '90vw',
                marginLeft: '1rem',
                marginBottom: '0.5rem',
                borderRadius: '20px',
              }}
              onChange={onChange}
              value={value}
              valid={iban.length === 26 && expr ? true : false}
              invalid={iban.length === 26 && !expr ? true : false}
            />
          </React.Fragment>
        );
      }}
    />
  );
};

IbanInput.propTypes = {
  setIban: PropTypes.func,
};

export default IbanInput;
